import React from 'react';

interface TextFieldProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  isEditing: boolean;
  inputWidth?: string;
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  isEditing,
  inputWidth = 'w-32',
}) => {
  return (
    <div className='flex justify-between items-start'>
      <span className='text-gray-600'>{label}:</span>
      {isEditing ? (
        <input
          type='text'
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={`text-xs px-2 py-1 border border-gray-300 rounded ${inputWidth}`}
        />
      ) : (
        <span className='font-medium text-gray-800 text-right'>{value}</span>
      )}
    </div>
  );
};
